export default "__VITE_ASSET__C8$$EiVc__"